import React from "react";

interface FontSelectorProps {
  value: string;
  onChange: (font: string) => void;
}

export const FontSelector: React.FC<FontSelectorProps> = ({
  value,
  onChange,
}) => {
  const fonts = [
    { label: "霞鹜文楷", value: "LXGW WenKai" },
    { label: "思源黑体", value: "Noto Sans SC" },
    { label: "思源宋体", value: "Noto Serif SC" },
    { label: "站酷高端黑", value: "ZCOOL KuaiLe" },
  ];

  return (
    <div className="space-y-2">
      {fonts.map((font) => (
        <button
          key={font.value}
          className={`w-full text-left px-3 py-2 rounded ${
            value === font.value
              ? "bg-gray-600 text-white"
              : "bg-gray-800 text-gray-300 hover:bg-gray-700"
          }`}
          style={{ fontFamily: font.value }}
          onClick={() => onChange(font.value)}
        >
          {font.label}
        </button>
      ))}
    </div>
  );
};
